import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Plus, Minus } from 'lucide-react';
const faqs = [{
  q: '¿Necesito experiencia previa?',
  a: 'No. El programa está diseñado para que puedas empezar desde cero, sin conocimientos técnicos previos. El Módulo 1 cubre todos los fundamentos paso a paso, con un lenguaje claro y aplicado.'
}, {
  q: '¿Las clases quedan grabadas?',
  a: 'Sí. Todas las clases en vivo se graban y quedan disponibles para que las puedas ver cuando quieras, las veces que necesites. Además, tenés acceso a todo el material descargable.'
}, {
  q: '¿Está basado en normativa vigente?',
  a: 'Sí. Todo el contenido del programa está construido sobre la normativa eléctrica actual aplicada en Argentina, incluyendo buenas prácticas, seguridad y criterios profesionales reconocidos.'
}, {
  q: '¿Voy a aprender desde cero?',
  a: 'Sí. El Módulo 1 cubre los fundamentos teóricos y técnicos completos: teoría eléctrica, componentes, materiales y lectura de planos. Vas paso a paso hasta llegar a instalaciones reales.'
}, {
  q: '¿Es una formación práctica?',
  a: 'Sí. Cada concepto se aplica a casos reales de viviendas. Vas a aprender cableado, montaje de tableros, conexiones seguras y proyectos residenciales completos con criterio profesional.'
}, {
  q: '¿Voy a tener acompañamiento?',
  a: 'Sí. Tenés soporte directo del docente durante las clases en vivo, donde podés hacer preguntas, mostrar tu trabajo y recibir correcciones personalizadas. No estás solo en el proceso.'
}];
function FAQItem({
  q,
  a,
  isOpen,
  onClick
}: {
  q: string;
  a: string;
  isOpen: boolean;
  onClick: () => void;
}) {
  return <div className="bg-ed-dark border border-zinc-800 rounded-2xl overflow-hidden hover:border-ed-green/30 transition-colors" data-id="element-142">
      <button onClick={onClick} className="w-full flex items-center justify-between gap-4 p-6 text-left" aria-expanded={isOpen} data-id="element-143">
        <span className="text-white font-bold text-base sm:text-lg" data-id="element-144">{q}</span>
        <div className="w-8 h-8 rounded-full bg-ed-green/10 border border-ed-green/30 flex items-center justify-center shrink-0" data-id="element-145">
          {isOpen ? <Minus className="w-4 h-4 text-ed-green" data-id="element-146" /> : <Plus className="w-4 h-4 text-ed-green" data-id="element-147" />}
        </div>
      </button>
      <AnimatePresence initial={false} data-id="element-148">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3,
        ease: 'easeInOut'
      }} className="overflow-hidden" data-id="element-149">
            <div className="px-6 pb-6 text-zinc-400 leading-relaxed" data-id="element-150">{a}</div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section id="faq" className="py-24 bg-ed-black relative border-t border-white/5" data-id="element-151">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-152">
        <div className="text-center mb-14" data-id="element-153">
          <span className="text-ed-green font-bold tracking-widest uppercase text-sm mb-3 block" data-id="element-154">
            Resolvemos tus dudas
          </span>
          <h2 className="text-4xl sm:text-5xl font-black uppercase tracking-tight text-white" data-id="element-155">
            Preguntas frecuentes
          </h2>
        </div>

        <div className="space-y-3" data-id="element-156">
          {faqs.map((faq, i) => <FAQItem key={i} q={faq.q} a={faq.a} isOpen={openIndex === i} onClick={() => setOpenIndex(openIndex === i ? null : i)} data-id="element-157" />)}
        </div>
      </div>
    </section>;
}